import React from "react";
import hervestlogo from "../../assets/images/hervestLogo.svg";
import { motion } from "framer-motion";

function OnboardingLayout({ children, footer }) {
  return (
    <div className="bg-onboarding overflow-hidden w-screen h-screen backdrop-brightness-25 items-center bg-[#EFEAED] ">
      <div className="px-4 md:px-8 md:py-4 py-10 grid justify-items-center">
        <a href="/">
          <img loading="lazy" src={hervestlogo} alt="HerVest Logo"></img>
        </a>
        <motion.div
          className="bg-white my-10 md:m-10 rounded-2xl p-5 md:p-10 w-full lg:w-[457px]"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5 }}
        >
          {children}
        </motion.div>

        {/* </div> */}

        {footer}
      </div>
    </div>
  );
}

export default OnboardingLayout;
